import React from "react";
import "./Navbar.css";
import Logotip from "../assets/ktri_new.png";
import { NavLink } from "react-router-dom";
import Account from "./account/account";

const Navbar = () => {
  return (
    <nav className="NavbarItems">
      <div className="container-fluid">
        <div className="bar">
          <div className="navbar-logo">
            <div className="logo">
              <img alt="logo" src={Logotip} />
            </div>
            <NavLink to="/">
              <div className="kasbiy">KASBIY TA'LIMNI  <br /> RIVOJLANTIRISH <br /> INSTITUTI </div>
            </NavLink>
          </div>

          <ul className="nav-menu">
          
            <li>
              <NavLink className="nav-link" to="/rtr">
                Raqamli ta’lim resurslari
              </NavLink>
            </li>
            <li>
              <NavLink className="nav-link" to="/professiogramma">
                Professiogrammalar
              </NavLink>
            </li>
            <li>
              <NavLink className="nav-link" to="/VideoMaterial">
                Video materiallar
              </NavLink>
            </li>
            <li>
              <NavLink className="nav-link" to="/contact">
                Testlar to'plami
              </NavLink>
            </li>
            <li>
              <NavLink className="nav-link" to="/loyiha-haqida">
                Mualliflar ro'yxati
              </NavLink>
            </li>
          </ul>
          <Account />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
